import * as mock from "../mocks/deviceTypes.mock.js";

export function listDeviceTypes() {
  return mock.listDeviceTypes();
}

export function createDeviceType(payload) {
  return mock.createDeviceType(payload);
}

export function updateDeviceType(deviceTypeId, payload) {
  return mock.updateDeviceType(deviceTypeId, payload);
}

export function deleteDeviceType(deviceTypeId) {
  return mock.deleteDeviceType(deviceTypeId);
}

export { DEVICE_COLUMN_TYPES, DEVICE_TYPE_STATUSES } from "../mocks/deviceTypes.mock.js";
